import { tagsApi } from '../api/base';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { CreateTagDto, IPagingData, TagDto, UpdateTagDto } from '@sr/dto';

export const useTags = (pagination?: IPagingData) => {
  const { isLoading, error, data } = tagsApi.useGetAllQuery( { paging: pagination || { page: 0, itemsPerPage: 25 } } );
  return {
    isLoading,
    error: extractNestJsErrorMessage(error),
    items: data?.items || [],
    totalItemsCount: data?.totalItemsCount || 0
  };
};

export const useCreateTag = () => {
  const [create] = tagsApi.useCreateMutation();

  return (dto: CreateTagDto) => {
    return create(dto).unwrap();
  };
};

export const useDeleteTag = () => {
  const [deleteTag] = tagsApi.useDeleteMutation();

  return (id: number) => {
    return deleteTag(id).unwrap();
  };
};

export const useUpdateTag = () => {
  const [update] = tagsApi.useUpdateMutation();

  return (dto: UpdateTagDto) => {
    return update(dto).unwrap();
  };
};

export const useTag = (id: number) => {
  const { error, data, isLoading } = tagsApi.useGetQuery(id, { refetchOnMountOrArgChange: 60 });
  const [update] = tagsApi.useUpdateMutation();
  const [deleteTag] = tagsApi.useDeleteMutation();

  return {
    error: extractNestJsErrorMessage(error),
    isLoading,
    tag: data,
    update: async (dto: Omit<TagDto, 'id'>) => {
      return update({ id, ...dto }).unwrap();
    },
    delete: async () => {
      return deleteTag(id).unwrap();
    }
  };
};
